// === src/wa/api/wa_menu_Api.js ===
import axios from "axios";

const API_URL = "https://wabot.netizar.com/api";

// -----------------------------------------------------------------------------
// 🧩 OPCIONES DE MENÚ (CRUD)
// -----------------------------------------------------------------------------

// 📋 Listar todas las opciones de un menú
export async function waGetOpcionesByMenu(menuId) {
    try {
        const { data } = await axios.get(`${API_URL}/opciones/${menuId}`);
        return data;
    } catch (err) {
        console.error("❌ Error al obtener opciones:", err);
        return [];
    }
}

// ➕ Crear nueva opción
export async function waCreateOpcion(opcion) {
    try {
        const { data } = await axios.post(`${API_URL}/opciones`, opcion);
        return data;
    } catch (err) {
        console.error("❌ Error al crear opción:", err);
        throw err;
    }
}

// ✏️ Actualizar opción existente
export async function waUpdateOpcion(id, opcion) {
    try {
        const { data } = await axios.put(`${API_URL}/opciones/${id}`, opcion);
        return data;
    } catch (err) {
        console.error("❌ Error al actualizar opción:", err);
        throw err;
    }
}

// 🗑️ Eliminar opción
export async function waDeleteOpcion(id) {
    try {
        const { data } = await axios.delete(`${API_URL}/opciones/${id}`);
        return data;
    } catch (err) {
        console.error("❌ Error al eliminar opción:", err);
        throw err;
    }
}

// -----------------------------------------------------------------------------
// 📚 MENÚS PRINCIPALES (si los usás en otro componente)
// -----------------------------------------------------------------------------

// Obtener todos los menús
export async function waGetMenus() {
    try {
        const { data } = await axios.get(`${API_URL}/menus`);
        return data;
    } catch (err) {
        console.error("❌ Error al obtener menús:", err);
        return [];
    }
}

// Crear nuevo menú
export async function waCreateMenu(menu) {
    try {
        const { data } = await axios.post(`${API_URL}/menus`, menu);
        return data;
    } catch (err) {
        console.error("❌ Error al crear menú:", err);
        throw err;
    }
}

// Actualizar menú
export async function waUpdateMenu(id, menu) {
    try {
        const { data } = await axios.put(`${API_URL}/menus/${id}`, menu);
        return data;
    } catch (err) {
        console.error("❌ Error al actualizar menú:", err);
        throw err;
    }
}

// Eliminar menú
export async function waDeleteMenu(id) {
    try {
        const { data } = await axios.delete(`${API_URL}/menus/${id}`);
        return data;
    } catch (err) {
        console.error("❌ Error al eliminar menú:", err);
        throw err;
    }
}

// ⭐ Marcar menú como principal (activar)
export async function waActivateMenu(id) {
    try {
        const { data } = await axios.put(`${API_URL}/menus/activate/${id}`);
        return data;
    } catch (err) {
        console.error("❌ Error al activar menú:", err);
        throw err;
    }
}

export async function waUploadEnvio(file) {
    const API = (localStorage.getItem("API") || "https://wabot.netizar.com").replace(/\/+$/, "");
    const token = localStorage.getItem("token") || "";

    const formData = new FormData();
    formData.append("file", file);

    const { data } = await axios.post(`${API}/api/envios/upload`, formData, {
        headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "multipart/form-data",
        },
    });

    return data;
}

// -----------------------------------------------------------------------------
// 📱 RESPONSABLES SMS
// -----------------------------------------------------------------------------

export async function getSmsResponsables() {
    try {
        const { data } = await axios.get(`${API_URL}/sms-responsables`);
        return data;
    } catch (err) {
        console.error("❌ Error al obtener responsables SMS:", err);
        return [];
    }
}

export async function createSmsResponsable(responsable) {
    try {
        const { data } = await axios.post(`${API_URL}/sms-responsables`, responsable);
        return data;
    } catch (err) {
        console.error("❌ Error al crear responsable SMS:", err);
        throw err;
    }
}

export async function updateSmsResponsable(id, responsable) {
    try {
        const { data } = await axios.put(`${API_URL}/sms-responsables/${id}`, responsable);
        return data;
    } catch (err) {
        console.error("❌ Error al actualizar responsable SMS:", err);
        throw err;
    }
}

export async function deleteSmsResponsable(id) {
    try {
        const { data } = await axios.delete(`${API_URL}/sms-responsables/${id}`);
        return data;
    } catch (err) {
        console.error("❌ Error al eliminar responsable SMS:", err);
        throw err;
    }
}

export async function getSucursales() {
    try {
        const { data } = await axios.get(`${API_URL}/sms-responsables/sucursales`);
        return data;
    } catch (err) {
        console.error("❌ Error al obtener sucursales:", err);
        return [];
    }
}